import BaseDataProvider from './baseDataProvider.js';
import WindowedDataRepository from './windowedDataRepository.js';
import SmokeyStateProvider from './smokeyStateProvider.js';

angular
    .module('signalview.streamDataProviders', [])
    .factory('BaseDataProvider', BaseDataProvider)
    .factory('WindowedDataRepository', WindowedDataRepository)
    .factory('SmokeyStateProvider', SmokeyStateProvider);
